import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import MonitorService from 'src/controllers/MonitorService';
import { selectionTypes } from 'src/components/utils/consts';
import { abbreviate } from 'src/components/utils/utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import AgentCard from './agentcard';
import { Row } from 'react-bootstrap';
import WidgetSettings from "src/components/dashboard/widgets/widgetsettings";
import ChatsService from 'src/controllers/ChatController';

const sortByACDStatus = (a, b) => {
    var val1 = a.strAcdStatus,
        val2 = b.strAcdStatus,
        indexA = 0,
        indexB = 0;

    switch (val1) {
        case "Free":
        case "Wrapup":
            indexA = -4;
            break;
        case "Paused":
            indexA = -3;
            break;
        case "Unregistered":
            indexA = -2;
            break;
        case "LoggedOut":
            indexA = -1;
            break;
        default:
            indexA = 0;
            break;
    }
    switch (val2) {
        case "Free":
        case "Wrapup":
            indexB = -4
            break;
        case "Paused":
            indexB = -3
            break;
        case "Unregistered":
            indexB = -2
            break;
        case "LoggedOut":
            indexB = -1
            break;
        default:
            indexB = 0;
            break;
    }

    return indexA > indexB ? -1 : 1;

}

const sortByACDStatusDesc = (a, b) => {
    var val1 = a.strAcdStatus,
        val2 = b.strAcdStatus,
        indexA = 0,
        indexB = 0;

    switch (val1) {
        case "Free":
        case "Wrapup":
            indexA = -1
            break;
        case "Paused":
            indexA = -2;
            break;
        case "Unregistered":
            indexA = -3;
            break;
        case "LoggedOut":
            indexA = -4;
            break;
        default:
            indexA = -5;
            break;
    }
    switch (val2) {
        case "Free":
        case "Wrapup":
            indexB = -1;
            break;
        case "Paused":
            indexB = -2;
            break;
        case "Unregistered":
            indexB = -3;
            break;
        case "LoggedOut":
            indexB = -4;
            break;
        default:
            indexB = -5;
            break;
    }

    return indexA > indexB ? -1 : 1;

}
class AgentsPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showSettings: false,
            agents: [],
            groupId: -1,
            groupName: "",
            chatAgents: [],
            asc: false
        };

        this.updateState = this.updateState.bind(this);
        this.setGroup = this.setGroup.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
        this.toggleSort = this.toggleSort.bind(this);
    }

    componentDidMount() {
        if (MonitorService?.stompClient?.connected) {
            let groupId = parseInt(localStorage.getItem(`agentscards_groupId_${this.props.userId}`) || -1);
            let groupName = localStorage.getItem(`agentscards_groupName_${this.props.userId}`) || this.props.t("all2");

            this.setState({
                groupId: groupId,
                groupName: groupName
            });
            ChatsService.getAgents(this.props.userId, agents => {

                let agentsList = [{
                    pin: -1,
                    name: this.props.t("none")
                }];
                if (agents.data != null && agents.data.length > 0)
                    agentsList = agentsList.concat(agents.data);
                this.setState({
                    chatAgents: agentsList.map(x => x.pin)
                });

            })
            MonitorService.stompClient.send("/app/subscribe/agentscards", {}, JSON.stringify({
                token: this.props.token,
                groupId: groupId
            }));

            MonitorService.stompClient.subscribe(`/user/${this.props.token}/topic/agentscards/`, this.updateState, { id: "agentscards" });
        } else {

        }
    }

    componentWillUnmount() {
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/unsubscribe/agentscards", {}, JSON.stringify({
                token: this.props.token,
            }));

            MonitorService.stompClient.unsubscribe("agentscards");
        }
    }

    setGroup(groupId, groupName) {

        this.setState({
            groupId: groupId,
            groupName: groupName,
            showSettings: !this.state.showSettings
        });

        localStorage.setItem(`agentscards_groupId_${this.props.userId}`, groupId);
        localStorage.setItem(`agentscards_groupName_${this.props.userId}`, groupName);
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/agentscards", {}, JSON.stringify({
                token: this.props.token,
                groupId: groupId
            }));
        }

    };

    toggleSettings() {
        this.setState({
            showSettings: !this.state.showSettings
        });
    }

    updateState(agents) {
        var data = JSON.parse(agents.body);

        if (this.state.asc) {
            data.sort(sortByACDStatus);
        } else {
            data.sort(sortByACDStatusDesc);
        }

        this.setState({
            agents: data
        })
    }

    toggleSort() {
        let asc = !this.state.asc;
        let agents = this.state.agents;
        if (asc) {
            agents.sort(sortByACDStatus);
        } else {
            agents.sort(sortByACDStatusDesc);
        }

        this.setState({
            asc: !this.state.asc,
            agents: agents
        });
    }

    render() {
        return (
            <div className='position-relative' style={{ top: 10, height: "99%" }}>
                <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} style={{ width: "100%", height: "100%", margin: "0px" }}>
                    <div className="card-header drag-handle">
                        <h3 className="card-title align-items-start flex-column text-primary">
                            <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("address-card")} /> {this.props.t("agentspanel")} - {this.state.groupName} <span className="badge badge-light-primary fs-base">{this.state.agents.length}</span></span>
                        </h3>
                        <div className="card-toolbar" style={{ zIndex: 1000 }}>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("sort")}
                                </Tooltip>}>
                                <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={this.toggleSort} >
                                    {
                                        this.state.asc &&
                                        <FontAwesomeIcon size="lg" icon={duotone("arrow-up")} />
                                    }
                                    {
                                        !this.state.asc &&
                                        <FontAwesomeIcon size="lg" icon={duotone("arrow-down")} />
                                    }
                                </button>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("config")}
                                </Tooltip>}>
                                <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={this.toggleSettings} >
                                    <FontAwesomeIcon icon={duotone("grid-2")} />
                                </button>
                            </OverlayTrigger>

                        </div>
                    </div>
                    <div className="card-body" style={{ height: "460px", overflow: "auto", padding: "0rem 2.25rem" }}>
                        <Row>
                            {
                                this.state.agents.map(v => {
                                    v.initials = abbreviate(v.name);
                                    return <AgentCard key={v.pin} agent={v} chatAgents={this.state.chatAgents}></AgentCard>
                                })
                            }
                        </Row>
                    </div>
                </div>

                <WidgetSettings showSettings={this.state.showSettings} toggleSettings={this.toggleSettings} token={this.props.token} setGroup={this.setGroup} groupId={this.state.groupId} groupName={this.state.groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
    };
};
export default compose(connect(mapStateToProps, null), withTranslation())(AgentsPanel);